var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.4848C21 17.8889 20.8586 18.2323 20.5758 18.5152L18.5152 20.5758C18.2323 20.8586 17.8889 21 17.4848 21C17.0808 21 16.7374 20.8586 16.4545 20.5758L12 16.1212L7.54545 20.5758C7.26263 20.8586 6.91919 21 6.51515 21C6.11111 21 5.76768 20.8586 5.48485 20.5758L3.42424 18.5152C3.14141 18.2323 3 17.8889 3 17.4848C3 17.0808 3.14141 16.7374 3.42424 16.4545L7.87879 12L3.42424 7.54545C3.14141 7.26263 3 6.91919 3 6.51515C3 6.11111 3.14141 5.76768 3.42424 5.48485L5.48485 3.42424C5.76768 3.14141 6.11111 3 6.51515 3C6.91919 3 7.26263 3.14141 7.54545 3.42424L12 7.87879L16.4545 3.42424C16.7374 3.14141 17.0808 3 17.4848 3C17.8889 3 18.2323 3.14141 18.5152 3.42424L20.5758 5.48485C20.8586 5.76768 21 6.11111 21 6.51515C21 6.91919 20.8586 7.26263 20.5758 7.54545L16.1212 12L20.5758 16.4545C20.8586 16.7374 21 17.0808 21 17.4848Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.598405db.svg";
export { ForwardRef as ReactComponent };